import MatchesHeadMeta from './MatchesHeadMeta';

export default MatchesHeadMeta;
